<template>
    <div v-if="!$root.isMobile" class="row" style="margin-top:30px;display:flex; justify-content:center;">
        <div class="col-md-12 mb-3">
            <div class="card shadow" style="border-radius: 20px;"
                :style="{ marginTop: '10px', height: $root.isMobile ? '80px' : '140px', position: 'relative' }">
                <div v-if="!$root.isTablet" class="card-body d-flex align-items-center">
                    <div class="row no-gutters w-100 align-items-center">
                        <div v-if="!$root.isMobile" class="col mr-2">
                            <div class="font-weight-bold text-ecomm h3 mb-1">
                                Gestionale DC Power {{ $root.VERSIONE }}
                            </div>
                            <div class="h6 mb-0 text-gray-800">
                                <strong>Utente</strong> {{ $root.utente.USERNAME }}
                            </div>
                            <div class="h6 mb-0 mt-1 text-gray-800">Developed by iSprint</div>
                        </div>

                        <div style="position:absolute; left:50%; transform:translateX(-50%);">
                            <!-- <button class="btn btn-success mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px;"
                                v-on:click="openUpload()">
                                <i class="fal fa-plus" style="font-size:18px; margin-right:5px;"></i>
                                Carica Flusso
                            </button> -->

                            <button class="btn btn-primary mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px;"
                                v-on:click="elaboraDati()">
                                <i class="fal fa-repeat" style="font-size:18px; margin-right:5px;"></i>
                                Elabora Dati
                            </button>

                            <button class="btn btn-info mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px;"
                                v-on:click="openInfoNomiFile()">
                                <i class="fal fa-question-circle" style="font-size:18px; margin-right:5px;"></i>
                                Come nominare i file
                            </button>

                            <button v-if="$root.utente.FK_ID_LIVELLO == 1" class="btn btn-warning mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px;"
                                data-toggle="modal" data-target="#modalAdmin">
                                <i class="fal fa-tools" style="font-size:18px; margin-right:5px;"></i>
                                Admin
                            </button>

                        </div>

                        <div v-if="!$root.isMobile" class="col-auto">
                            <img src="~@/assets/dcpower.png" style="margin: 0 auto; max-height:80px;"
                                class="img-responsive">
                        </div>
                    </div>

                    <!-- Pulsante Esporta Excel - angolo in basso a destra -->
                    <button class="btn btn-success"
                        style="position: absolute; bottom: 0; right: 0; width: 40px; height: 40px; border-radius: 50% 0 20px 0; padding: 0;"
                        v-on:click="esportaAgenti()" title="Esporta tutte le statistiche in Excel">
                        <i class="fal fa-file-excel"></i>
                    </button>
                </div>
                <div v-else class="card-body d-flex align-items-center">
                    <div class="row no-gutters w-100 align-items-center">
                        <div v-if="!$root.isMobile" class="col mr-2">
                            <div class="font-weight-bold text-ecomm h3 mb-1">
                                Gestionale DC Power {{ $root.VERSIONE }}
                            </div>
                            <div class="h6 mb-0 text-gray-800">
                                <strong>Utente</strong> {{ $root.utente.USERNAME }}
                            </div>
                            <div class="h6 mb-0 mt-1 text-gray-800">Developed by iSprint</div>
                        </div>

                        <div :style="{
                            position: 'absolute',
                            left: isTablet ? 'unset' : '70%',
                            right: isTablet ? '10px' : 'unset',
                            display: 'flex',
                            flexDirection: isTablet ? 'column' : 'row',
                            justifyContent: isTablet ? 'flex-end' : 'center',
                            alignItems: 'center'
                        }">
                            <!-- <button class="btn btn-success mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px; width: auto; max-width: 250px;"
                                v-on:click="openUpload()">
                                <i class="fal fa-plus" style="font-size:18px; margin-right:5px;"></i>
                                Carica Flusso
                            </button> -->

                            <button class="btn btn-primary mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px; width: auto; max-width: 250px;"
                                v-on:click="elaboraDati()">
                                <i class="fal fa-repeat" style="font-size:18px; margin-right:5px;"></i>
                                Elabora Dati
                            </button>

                            <button class="btn btn-info mx-1"
                                style="padding: 12px 24px; font-size: 16px; border-radius: 10px; width: auto; max-width: 250px;"
                                v-on:click="openInfoNomiFile()">
                                <i class="fal fa-question-circle" style="font-size:18px; margin-right:5px;"></i>
                                Come nominare i file
                            </button>
                        </div>

                    </div>
                </div>
                

            </div>

            <!-- CARD STATISTICHE GENERALI - RIGA SIMMETRICA -->
            <div class="row justify-content-center">
                <!-- CARD AGENTI -->
                <div class="col-lg-3 col-md-6 col-12 mb-4">
                    <div class="card shadow lift-panel h-100" v-on:click="openModulo('agenti')"
                        style="margin-top:20px; background: linear-gradient(135deg,#3434D9,#34A8D9); border-radius: 20px; cursor: pointer;">
                        <div class="card-body text-center d-flex flex-column justify-content-center">
                            <div>
                                <i class="fal fa-user-secret fa-4x" style="color:#fff"></i>
                            </div>
                            <div class="font-weight-bold mb-1 h4 mt-2" style="color:#fff !important">Agenti</div>
                            <div class="small" style="color:#fff; opacity: 0.9;">Visualizza e gestisci</div>
                        </div>
                    </div>
                </div>

                <!-- CARD FATTURE -->
                <div class="col-lg-3 col-md-6 col-12 mb-4" v-if="stats">
                    <div class="card shadow lift-panel h-100" v-on:click="openDettagliFatture()"
                        style="margin-top:20px; border-radius: 20px; cursor: pointer;">
                        <div class="card-body text-center d-flex flex-column justify-content-center">
                            <h5 class="mb-3" style="font-weight: bold; color: #2196f3;">
                                <i class="fas fa-file-invoice"></i> FATTURE
                            </h5>
                            <div class="row">
                                <div class="col-4 text-center">
                                    <div style="font-size: 0.75rem; color: #6c757d;">MC Elab</div>
                                    <div style="font-size: 1.1rem; font-weight: bold; color: #4caf50;">
                                        {{ filters.formattaImportoInt(stats.MC_ELABORATI) }}
                                    </div>
                                </div>
                                <div class="col-4 text-center">
                                    <div style="font-size: 0.75rem; color: #6c757d;">MC Incass</div>
                                    <div style="font-size: 1.1rem; font-weight: bold; color: #2196f3;">
                                        {{ filters.formattaImportoInt(stats.MC_INCASSATI) }}
                                    </div>
                                </div>
                                <div class="col-4 text-center">
                                    <div style="font-size: 0.75rem; color: #6c757d;">MC Portaf</div>
                                    <div style="font-size: 1.1rem; font-weight: bold; color: #ff9800;">
                                        {{ filters.formattaImportoInt(stats.MC_IN_PORTAFOGLIO) }}
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3" style="font-size: 0.8rem; color: #999;">
                                <i class="fas fa-info-circle"></i> Clicca per dettagli
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CARD CONTRATTI -->
                <div class="col-lg-3 col-md-6 col-12 mb-4" v-if="stats">
                    <div class="card shadow lift-panel h-100" v-on:click="openDettagliContratti()"
                        style="margin-top:20px; border-radius: 20px; cursor: pointer;">
                        <div class="card-body text-center d-flex flex-column justify-content-center">
                            <h5 class="mb-3" style="font-weight: bold; color: #ff9800;">
                                <i class="fas fa-file-contract"></i> CONTRATTI
                            </h5>
                            <div class="row">
                                <div class="col-6 text-center" style="border-right: 1px solid #eee;">
                                    <div style="font-size: 0.75rem; color: #6c757d;"><i class="fas fa-lightbulb"></i> POD</div>
                                    <div style="font-size: 1.2rem; font-weight: bold; color: #ff9800;">{{ stats.TOTALE_POD }}</div>
                                    <div style="font-size: 0.7rem; color: #4caf50;">{{ stats.POD_ATTIVI }} attivi</div>
                                </div>
                                <div class="col-6 text-center">
                                    <div style="font-size: 0.75rem; color: #6c757d;"><i class="fas fa-fire"></i> PDR</div>
                                    <div style="font-size: 1.2rem; font-weight: bold; color: #ff9800;">{{ stats.TOTALE_PDR }}</div>
                                    <div style="font-size: 0.7rem; color: #4caf50;">{{ stats.PDR_ATTIVI }} attivi</div>
                                </div>
                            </div>
                            <div class="mt-3" style="font-size: 0.8rem; color: #999;">
                                <i class="fas fa-info-circle"></i> Clicca per dettagli
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CARD FINANZIARIO -->
                <div class="col-lg-3 col-md-6 col-12 mb-4" v-if="stats">
                    <div class="card shadow h-100" style="margin-top:20px; border-radius: 20px;">
                        <div class="card-body text-center d-flex flex-column justify-content-center">
                            <h5 class="mb-3" style="font-weight: bold; color: #4caf50;">
                                <i class="fas fa-euro-sign"></i> FINANZIARIO
                            </h5>
                            <div class="row">
                                <div class="col-6 text-center" style="border-right: 1px solid #eee;">
                                    <div style="font-size: 0.75rem; color: #6c757d;">Dovuto Tot</div>
                                    <div style="font-size: 1.2rem; font-weight: bold; color: #f44336;">
                                        {{ filters.formattaImporto(stats.DOVUTO_TOTALE) }}€
                                    </div>
                                </div>
                                <div class="col-6 text-center">
                                    <div style="font-size: 0.75rem; color: #6c757d;">Pagamenti</div>
                                    <div style="font-size: 1.2rem; font-weight: bold; color: #4caf50;">
                                        {{ filters.formattaImporto(stats.TOTALE_PAGAMENTI) }}€
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        


        <div class="col-lg col-md-6 col-12" style="height: 140px; margin-bottom: 40px;">
            <div class="card shadow lift-panel" v-on:click="openModulo('clienti')"
                style="margin-top:20px; background: linear-gradient(135deg, #ff0000, #800080); border-radius: 20px;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff">Clienti</div>
                            <div class="h6 mb-0" style="color:#fff">Gestisci i clienti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-shopping-cart fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg col-md-6 col-12" style="height: 140px;margin-bottom: 40px;">
            <div class="card shadow lift-panel" v-on:click="openModulo('fatture')"
                style="margin-top:20px; background: linear-gradient(135deg, #800080, #004B80);border-radius: 20px;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Fatture</div>
                            <div class="h6 mb-0" style="color:#fff">Gestisci le fatture</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-file-invoice-dollar fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg col-md-6 col-12" style="height: 140px; margin-bottom: 40px;">
            <div class="card shadow lift-panel" v-on:click="openModulo('pagamenti')"
                style="margin-top:20px; background: linear-gradient(135deg, #004B80, #00802B);border-radius: 20px;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Pagamenti</div>
                            <div class="h6 mb-0" style="color:#fff">Gestisci i Pagamenti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-euro-sign fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg col-md-6 col-12" style="height: 140px; margin-bottom: 40px;">
            <div class="card shadow lift-panel" v-on:click="openModulo('logs')"
                style="margin-top:20px; background: linear-gradient(135deg, #00802B, #808000);border-radius: 20px;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Logs</div>
                            <div class="h6 mb-0" style="color:#fff">Gestisci i Log</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-cogs fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg col-md-6 col-12" style="height: 140px; margin-bottom: 40px;">
            <div class="card shadow lift-panel" v-on:click="openModulo('contratti')"
                style="margin-top:20px; background: linear-gradient(135deg, #808000, #D9CB34);border-radius: 20px;">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="font-weight-bold mb-1 h1" style="color:#fff !important">Contratti</div>
                            <div class="h6 mb-0" style="color:#fff">Visualizza i Contratti</div>
                        </div>
                        <div class="col-auto">
                            <i class="fal fa-file-contract fa-4x" style="color:#fff"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ALERT COMPLEANNI AGENTI -->
        <div v-if="$root.agentiCompleanno && $root.agentiCompleanno.length > 0" class="col-12 mb-4">
            <div class="alert alert-info shadow" style="border-radius: 15px; border-left: 5px solid #17a2b8;">
                <div class="d-flex align-items-center">
                    <i class="fad fa-birthday-cake fa-3x mr-3"
                       style="--fa-primary-color: #C4AC21; --fa-secondary-color: #FF0000;"></i>
                    <div>
                        <h5 class="mb-1">
                            <i class="fas fa-gift mr-2"></i>
                            <strong v-if="$root.agentiCompleanno.length === 1">Compleanno di oggi!</strong>
                            <strong v-else>Compleanni di oggi!</strong>
                        </h5>
                        <p class="mb-0" v-if="$root.agentiCompleanno.length === 1">
                            Oggi è il compleanno di <strong>{{ $root.agentiCompleanno[0] }}</strong>! 
                        </p>
                        <p class="mb-0" v-else>
                            Oggi festeggiano il compleanno <strong>{{ $root.agentiCompleanno.length }}</strong> agenti:
                            <strong>{{ $root.agentiCompleanno.join(", ") }}</strong>! 
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Admin -->
        <div class="modal fade" id="modalAdmin" tabindex="-1" role="dialog" aria-labelledby="modalAdminLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" style="border-radius: 20px; overflow: hidden;">
                    <div class="modal-header" style="background: linear-gradient(135deg, #ffa500, #ff6347); color: white; border: none;">
                        <h3 class="modal-title" id="modalAdminLabel">
                            <i class="fal fa-tools me-2"></i>Pannello Admin
                        </h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color: white; opacity: 1;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 40px;">
                        <div class="d-flex flex-column gap-3">
                            <button type="button" class="btn btn-primary btn-lg" v-on:click="openModulo('utenti')" data-dismiss="modal" style="padding: 15px; border-radius: 10px; font-size: 18px;">
                                <i class="fal fa-users me-2"></i>Gestisci Utenti
                            </button>
                            <button type="button" class="btn btn-danger btn-lg mt-3" @click="svuotaDb()" data-dismiss="modal" style="padding: 15px; border-radius: 10px; font-size: 18px;">
                                <i class="fal fa-trash-alt me-2"></i>Svuota Database
                            </button>
                            <button type="button" class="btn btn-warning btn-lg mt-3" @click="riassegnaAgente1917()" data-dismiss="modal" style="padding: 15px; border-radius: 10px; font-size: 18px;">
                                <i class="fal fa-exchange-alt me-2"></i>Riassegna contratti agente 19 &rarr; 17
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>








       <!--  <div class="modal fade" id="popUpUpload" data-backdrop="true" role="dialog" aria-modal="true">
            <div class="modal-dialog" style="min-width:300px;">
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #00802B;">
                        <h1 style="color:#fff" class="modal-title"><i class="fas fa-file-excel"></i> Carica Flussi</h1>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <Upload @onsuccess="successCaricamento()" :w="90" :args="args"></Upload>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
    <div v-else style="margin-top:30px;">
        <div class="col-md-12 mb-3">
            <div class="card shadow"
                :style="{ marginTop: '10px', height: $root.isMobile ? '150px' : '130px', position: 'relative' }">
                <!-- Icona Compleanno in basso a destra -->
                <div v-if="$root.agentiCompleanno && $root.agentiCompleanno.length > 0"
                     style="position: absolute; bottom: 10px; right: 10px; z-index: 10;">
                    <i class="fad fa-birthday-cake fa-2x"
                       style="--fa-primary-color: #C4AC21; --fa-secondary-color: #FF0000; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));"></i>
                </div>
                <div class="card-body text-center">
                    <div class="col mr-2">
                        <div class="font-weight-bold text-ecomm h3 mb-1">
                            Gestionale DC Power {{ $root.VERSIONE }}
                        </div>
                        <div class="h6 mb-0 text-gray-800">
                            <strong>Utente</strong> {{ $root.utente.USERNAME }}
                        </div>
                        <div class="h6 mb-0 mt-1 text-gray-800">Developed by iSprint</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pulsante Admin per mobile -->
        <!-- <div v-if="$root.utente.FK_ID_LIVELLO == 1" class="text-center mb-3">
            <button class="btn btn-warning"
                style="padding: 12px 24px; font-size: 16px; border-radius: 10px;"
                data-toggle="modal" data-target="#modalAdmin">
                <i class="fal fa-tools" style="font-size:18px; margin-right:5px;"></i>
                Admin
            </button>
        </div> -->

        <!-- Layout circolare per mobile -->
        <div style="position: relative; width: 100%; height: 400px;">

            <!-- Card Agenti al centro -->
            <div class="zoom-wrapper" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <div class="card shadow zoom-panel" v-on:click="openModulo('agenti')"
                    style="width: 140px; height: 140px; background: linear-gradient(135deg,#3434D9,#34A8D9);
                    display: flex; justify-content: center; align-items: center; border-radius: 50%; cursor: pointer;">
                    <i class="fal fa-user-secret fa-4x" style="color:#fff"></i>
                </div>
            </div>

            <!-- Card Clienti (0°, top) -->
            <div class="zoom-wrapper" style="position: absolute; top: calc(50% - 130px); left: 50%; transform: translate(-50%, -50%);">
                <div class="card shadow zoom-panel" v-on:click="openModulo('clienti')"
                    style="width: 110px; height: 110px; background: linear-gradient(135deg, #ff0000, #800080);
                    display: flex; justify-content: center; align-items: center; border-radius: 50%; cursor: pointer;">
                    <i class="fal fa-shopping-cart fa-3x" style="color:#fff"></i>
                </div>
            </div>

            <!-- Card Fatture (72°, top-right) -->
            <div class="zoom-wrapper" style="position: absolute; top: calc(50% - 40px); left: calc(50% + 123px); transform: translate(-50%, -50%);">
                <div class="card shadow zoom-panel" v-on:click="openModulo('fatture')"
                    style="width: 110px; height: 110px; background: linear-gradient(135deg, #800080, #004B80);
                    display: flex; justify-content: center; align-items: center; border-radius: 50%; cursor: pointer;">
                    <i class="fal fa-file-invoice-dollar fa-3x" style="color:#fff"></i>
                </div>
            </div>

            <!-- Card Pagamenti (144°, bottom-right) -->
            <div class="zoom-wrapper" style="position: absolute; top: calc(50% + 105px); left: calc(50% + 76px); transform: translate(-50%, -50%);">
                <div class="card shadow zoom-panel" v-on:click="openModulo('pagamenti')"
                    style="width: 110px; height: 110px; background: linear-gradient(135deg, #004B80, #00802B);
                    display: flex; justify-content: center; align-items: center; border-radius: 50%; cursor: pointer;">
                    <i class="fal fa-euro-sign fa-3x" style="color:#fff"></i>
                </div>
            </div>

            <!-- Card Logs (216°, bottom-left) -->
            <div class="zoom-wrapper" style="position: absolute; top: calc(50% + 105px); left: calc(50% - 76px); transform: translate(-50%, -50%);">
                <div class="card shadow zoom-panel" v-on:click="openModulo('logs')"
                    style="width: 110px; height: 110px; background: linear-gradient(135deg, #00802B, #808000);
                    display: flex; justify-content: center; align-items: center; border-radius: 50%; cursor: pointer;">
                    <i class="fal fa-cogs fa-3x" style="color:#fff"></i>
                </div>
            </div>

            <!-- Card Contratti (288°, top-left) -->
            <div class="zoom-wrapper" style="position: absolute; top: calc(50% - 40px); left: calc(50% - 123px); transform: translate(-50%, -50%);">
                <div class="card shadow zoom-panel" v-on:click="openModulo('contratti')"
                    style="width: 110px; height: 110px; background: linear-gradient(135deg, #808000, #D9CB34);
                    display: flex; justify-content: center; align-items: center; border-radius: 50%; cursor: pointer;">
                    <i class="fal fa-file-contract fa-3x" style="color:#fff"></i>
                </div>
            </div>

        </div>

        <!-- Pulsanti Info e Excel per mobile -->
        <div class="text-center mt-3" style="display: flex; justify-content: center; gap: 15px;">
            <button class="btn btn-info" v-on:click="moreInfo()" style="padding: 10px 20px; border-radius: 10px;">
                <i class="fal fa-info-circle"></i> Dettagli
            </button>
            <button class="btn btn-success" v-on:click="esportaAgenti()" style="padding: 10px 20px; border-radius: 10px;">
                <i class="fal fa-file-excel"></i> Excel
            </button>
        </div>





        <!-- <div class="modal fade" id="popUpUpload" data-backdrop="true" role="dialog" aria-modal="true">
                <div class="modal-dialog" style="min-width:300px;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 style="color:#fff" class="modal-title"><i class="fas fa-file-excel"></i> Carica Flussi
                            </h1>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div>
                                <Upload @onsuccess="successCaricamento()" :w="90" :args="args"></Upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         -->

    </div>

    <!-- POPUP DETTAGLI FATTURE -->
    <div class="modal fade" id="popUpDettagliFatture" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border-radius: 15px; overflow: hidden;">
                <div class="modal-header" style="background: #2196f3; color: white;">
                    <h5 class="modal-title">
                        <i class="fas fa-file-invoice"></i> Dettagli Fatture
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color: white; opacity: 1;">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="padding: 20px;" v-if="stats">
                    <!-- FATTURE GENERALE -->
                    <div class="mb-3 p-3 bg-light rounded">
                        <h6 class="mb-2"><i class="fas fa-file-invoice text-primary"></i> <strong>Generale</strong></h6>
                        <div class="row">
                            <div class="col-6 mb-2">Totali: <span class="badge badge-primary badge-pill">{{ stats.FATTURE_TOTALI }}</span></div>
                            <div class="col-6 mb-2">MC Totali: <span class="badge badge-secondary badge-pill">{{ filters.formattaImportoInt(stats.TOTALE_MC_FATTURATI) }} mc</span></div>
                            <div class="col-6 mb-2">Elaborate: <span class="badge badge-success badge-pill">{{ stats.FATTURE_ELABORATE }}</span></div>
                            <div class="col-6 mb-2">Non Elaborate: <span class="badge badge-danger badge-pill">{{ stats.FATTURE_NON_ELABORATE }}</span></div>
                            <div class="col-6 mb-2">Pagate Ag: <span class="badge badge-success badge-pill">{{ stats.FATTURE_PAGATE_AGENZIA }}</span></div>
                            <div class="col-6 mb-2">Non Pagate Ag: <span class="badge badge-warning badge-pill">{{ stats.FATTURE_NON_PAGATE_AGENZIA }}</span></div>
                        </div>
                    </div>

                    <!-- FATTURE ELABORATE -->
                    <div class="mb-3 p-3 bg-light rounded">
                        <h6 class="mb-2"><i class="fas fa-check-circle text-success"></i> <strong>Elaborate</strong></h6>
                        <div class="row">
                            <div class="col-6 mb-2">Fatture: <span class="badge badge-primary badge-pill">{{ stats.FATTURE_ELABORATE }}</span></div>
                            <div class="col-6 mb-2">MC Totali: <span class="badge badge-primary badge-pill">{{ filters.formattaImportoInt(stats.MC_ELABORATI) }} mc</span></div>
                            <div class="col-6 mb-2">MC Incassati: <span class="badge badge-success badge-pill">{{ filters.formattaImportoInt(stats.MC_INCASSATI) }} mc</span></div>
                            <div class="col-6 mb-2">MC Portafoglio: <span class="badge badge-warning badge-pill">{{ filters.formattaImportoInt(stats.MC_IN_PORTAFOGLIO) }} mc</span></div>
                            <div class="col-6 mb-2">Pagate Cli: <span class="badge badge-success badge-pill">{{ stats.FATTURE_PAGATE_CLIENTI }}</span></div>
                            <div class="col-6 mb-2">Da Pagare Cli: <span class="badge badge-warning badge-pill">{{ stats.FATTURE_DA_PAGARE_CLIENTI }}</span></div>
                        </div>
                    </div>

                    <!-- FATTURE NON ELABORATE -->
                    <div class="mb-3 p-3 bg-light rounded">
                        <h6 class="mb-2"><i class="fas fa-times-circle text-danger"></i> <strong>Non Elaborate</strong></h6>
                        <div class="row">
                            <div class="col-6 mb-2">Fatture: <span class="badge badge-danger badge-pill">{{ stats.FATTURE_NON_ELABORATE }}</span></div>
                            <div class="col-6 mb-2">MC Totali: <span class="badge badge-danger badge-pill">{{ filters.formattaImportoInt(stats.MC_NON_ELABORATI) }} mc</span></div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        <i class="fas fa-times"></i> Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- POPUP DETTAGLI CONTRATTI -->
    <div class="modal fade" id="popUpDettagliContratti" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border-radius: 15px; overflow: hidden;">
                <div class="modal-header" style="background: #ff9800; color: white;">
                    <h5 class="modal-title">
                        <i class="fas fa-file-contract"></i> Dettagli Contratti
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color: white; opacity: 1;">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="padding: 20px;" v-if="stats">
                    <!-- POD (Luce) -->
                    <div class="mb-3 p-3 bg-light rounded">
                        <h6 class="mb-2"><i class="fas fa-lightbulb text-warning"></i> <strong>POD (Luce)</strong></h6>
                        <div class="row">
                            <div class="col-6 mb-2">Totali: <span class="badge badge-primary badge-pill">{{ stats.TOTALE_POD }}</span></div>
                            <div class="col-6 mb-2">Attivi: <span class="badge badge-success badge-pill">{{ stats.POD_ATTIVI }}</span></div>
                            <div class="col-6 mb-2">Chiusi da Fatt: <span class="badge badge-info badge-pill">{{ stats.POD_CHIUSI_DA_FATTURARE }}</span></div>
                            <div class="col-6 mb-2">Attivi da Fatt: <span class="badge badge-warning badge-pill">{{ stats.POD_ATTIVI_DA_FATTURARE }}</span></div>
                            <div class="col-6 mb-2">In Attivazione: <span class="badge badge-secondary badge-pill">{{ stats.POD_IN_ATTIVAZIONE }}</span></div>
                            <div class="col-6 mb-2">Disattivati: <span class="badge badge-danger badge-pill">{{ stats.POD_DISATTIVATI }}</span></div>
                            <div class="col-6 mb-2">Pagati Ag: <span class="badge badge-success badge-pill">{{ stats.POD_PAGATI_AGENZIA }}</span></div>
                            <div class="col-6 mb-2">Non Pagati Ag: <span class="badge badge-danger badge-pill">{{ stats.POD_NON_PAGATI_AGENZIA }}</span></div>
                        </div>
                    </div>

                    <!-- PDR (Gas) -->
                    <div class="mb-3 p-3 bg-light rounded">
                        <h6 class="mb-2"><i class="fas fa-fire text-danger"></i> <strong>PDR (Gas)</strong></h6>
                        <div class="row">
                            <div class="col-6 mb-2">Totali: <span class="badge badge-primary badge-pill">{{ stats.TOTALE_PDR }}</span></div>
                            <div class="col-6 mb-2">Attivi: <span class="badge badge-success badge-pill">{{ stats.PDR_ATTIVI }}</span></div>
                            <div class="col-6 mb-2">Chiusi da Fatt: <span class="badge badge-info badge-pill">{{ stats.PDR_CHIUSI_DA_FATTURARE }}</span></div>
                            <div class="col-6 mb-2">Attivi da Fatt: <span class="badge badge-warning badge-pill">{{ stats.PDR_ATTIVI_DA_FATTURARE }}</span></div>
                            <div class="col-6 mb-2">In Attivazione: <span class="badge badge-secondary badge-pill">{{ stats.PDR_IN_ATTIVAZIONE }}</span></div>
                            <div class="col-6 mb-2">Disattivati: <span class="badge badge-danger badge-pill">{{ stats.PDR_DISATTIVATI }}</span></div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        <i class="fas fa-times"></i> Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- MODALE STATISTICHE GENERALI PER MOBILE -->
    <!-- POPUP INFO: COME NOMINARE I FILE -->
    <div class="modal fade" id="popUpInfoNomiFile" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border-radius:15px; overflow:hidden;">
                <div class="modal-header" style="background:#127787; color:#fff;">
                    <h5 class="modal-title"><i class="fal fa-file-excel"></i> Come nominare i file</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color:#fff; opacity:1;">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="padding:20px; text-align:left;">
                    <p>Perché un file venga elaborato, il <b>nome</b> deve contenere una di queste parole chiave:</p>
                    <ul>
                        <li><b>POD attivi</b> &rarr; il nome deve contenere <code>PDP Attivi</code></li>
                        <li><b>POD cessati</b> &rarr; <code>PDP Cessati</code> (oppure <code>Disattivi</code>)</li>
                        <li><b>Fatture</b> &rarr; <code>Fatturato</code></li>
                        <li><b>Agenti</b> &rarr; <code>Scadenzario</code></li>
                    </ul>
                    <p class="text-danger"><b>I file con nomi diversi non verranno elaborati.</b></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fas fa-times"></i> Chiudi</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="popUpInfoStats" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-info">
                    <h5 style="color:#fff" class="modal-title">
                        <i class="fas fa-chart-line"></i> Statistiche Dettagliate
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color: white; opacity: 1;">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="padding: 15px;" v-if="stats">
                    <div class="row">
                        <!-- COLONNA SINISTRA -->
                        <div class="col-md-6">
                            <!-- SEZIONE FATTURE - GENERALE -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-file-invoice text-primary"></i> <strong>FATTURE - GENERALE</strong></h6>
                                <div class="row">
                                    <div class="col-6 mb-1">Totali: <span class="badge badge-primary badge-pill">{{ stats.FATTURE_TOTALI }}</span></div>
                                    <div class="col-6 mb-1">MC Totali: <span class="badge badge-secondary badge-pill">{{ filters.formattaImportoInt(stats.TOTALE_MC_FATTURATI) }} mc</span></div>
                                    <div class="col-6 mb-1">Elaborate: <span class="badge badge-success badge-pill">{{ stats.FATTURE_ELABORATE }}</span></div>
                                    <div class="col-6 mb-1">Non Elaborate: <span class="badge badge-danger badge-pill">{{ stats.FATTURE_NON_ELABORATE }}</span></div>
                                    <div class="col-6 mb-1">Pagate Ag: <span class="badge badge-success badge-pill">{{ stats.FATTURE_PAGATE_AGENZIA }}</span></div>
                                    <div class="col-6 mb-1">Non Pagate Ag: <span class="badge badge-warning badge-pill">{{ stats.FATTURE_NON_PAGATE_AGENZIA }}</span></div>
                                </div>
                            </div>

                            <!-- SEZIONE FATTURE ELABORATE -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-check-circle text-success"></i> <strong>FATTURE ELABORATE</strong></h6>
                                <div class="row">
                                    <div class="col-6 mb-1">Fatture: <span class="badge badge-primary badge-pill">{{ stats.FATTURE_ELABORATE }}</span></div>
                                    <div class="col-6 mb-1">MC Totali: <span class="badge badge-primary badge-pill">{{ filters.formattaImportoInt(stats.MC_ELABORATI) }} mc</span></div>
                                    <div class="col-6 mb-1">MC Incassati: <span class="badge badge-success badge-pill">{{ filters.formattaImportoInt(stats.MC_INCASSATI) }} mc</span></div>
                                    <div class="col-6 mb-1">MC Portafoglio: <span class="badge badge-warning badge-pill">{{ filters.formattaImportoInt(stats.MC_IN_PORTAFOGLIO) }} mc</span></div>
                                    <div class="col-6 mb-1">Pagate Cli: <span class="badge badge-success badge-pill">{{ stats.FATTURE_PAGATE_CLIENTI }}</span></div>
                                    <div class="col-6 mb-1">Da Pagare Cli: <span class="badge badge-warning badge-pill">{{ stats.FATTURE_DA_PAGARE_CLIENTI }}</span></div>
                                </div>
                            </div>

                            <!-- SEZIONE FATTURE NON ELABORATE -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-times-circle text-danger"></i> <strong>FATTURE NON ELABORATE</strong></h6>
                                <div class="row">
                                    <div class="col-6 mb-1">Fatture: <span class="badge badge-danger badge-pill">{{ stats.FATTURE_NON_ELABORATE }}</span></div>
                                    <div class="col-6 mb-1">MC Totali: <span class="badge badge-danger badge-pill">{{ filters.formattaImportoInt(stats.MC_NON_ELABORATI) }} mc</span></div>
                                </div>
                            </div>

                            <!-- SEZIONE CONTRATTI POD -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-lightbulb text-warning"></i> <strong>POD (Luce)</strong></h6>
                                <div class="row">
                                    <div class="col-6 mb-1">Totali: <span class="badge badge-primary badge-pill">{{ stats.TOTALE_POD }}</span></div>
                                    <div class="col-6 mb-1">Attivi: <span class="badge badge-success badge-pill">{{ stats.POD_ATTIVI }}</span></div>
                                    <div class="col-6 mb-1">Chiusi da Fatt: <span class="badge badge-info badge-pill">{{ stats.POD_CHIUSI_DA_FATTURARE }}</span></div>
                                    <div class="col-6 mb-1">Attivi da Fatt: <span class="badge badge-warning badge-pill">{{ stats.POD_ATTIVI_DA_FATTURARE }}</span></div>
                                    <div class="col-6 mb-1">In Attivazione: <span class="badge badge-secondary badge-pill">{{ stats.POD_IN_ATTIVAZIONE }}</span></div>
                                    <div class="col-6 mb-1">Disattivati: <span class="badge badge-danger badge-pill">{{ stats.POD_DISATTIVATI }}</span></div>
                                    <div class="col-6 mb-1">Pagati Ag: <span class="badge badge-success badge-pill">{{ stats.POD_PAGATI_AGENZIA }}</span></div>
                                    <div class="col-6 mb-1">Non Pagati Ag: <span class="badge badge-danger badge-pill">{{ stats.POD_NON_PAGATI_AGENZIA }}</span></div>
                                </div>
                            </div>
                        </div>

                        <!-- COLONNA DESTRA -->
                        <div class="col-md-6">
                            <!-- SEZIONE CONTRATTI PDR -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-fire text-danger"></i> <strong>PDR (Gas)</strong></h6>
                                <div class="row">
                                    <div class="col-6 mb-1">Totali: <span class="badge badge-primary badge-pill">{{ stats.TOTALE_PDR }}</span></div>
                                    <div class="col-6 mb-1">Attivi: <span class="badge badge-success badge-pill">{{ stats.PDR_ATTIVI }}</span></div>
                                    <div class="col-6 mb-1">Chiusi da Fatt: <span class="badge badge-info badge-pill">{{ stats.PDR_CHIUSI_DA_FATTURARE }}</span></div>
                                    <div class="col-6 mb-1">Attivi da Fatt: <span class="badge badge-warning badge-pill">{{ stats.PDR_ATTIVI_DA_FATTURARE }}</span></div>
                                    <div class="col-6 mb-1">In Attivazione: <span class="badge badge-secondary badge-pill">{{ stats.PDR_IN_ATTIVAZIONE }}</span></div>
                                    <div class="col-6 mb-1">Disattivati: <span class="badge badge-danger badge-pill">{{ stats.PDR_DISATTIVATI }}</span></div>
                                </div>
                            </div>

                            <!-- SEZIONE FINANZIARIO - TOTALI -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-euro-sign text-success"></i> <strong>FINANZIARIO - TOTALI</strong></h6>
                                <div class="row">
                                    <div class="col-12 mb-2"><strong>DOVUTO TOTALE:</strong> <span class="badge badge-danger badge-pill" style="font-size: 1rem;">{{ filters.formattaImporto(stats.DOVUTO_TOTALE) }}€</span></div>
                                    <div class="col-12 mb-2"><strong>TOTALE PAGAMENTI:</strong> <span class="badge badge-success badge-pill" style="font-size: 1rem;">{{ filters.formattaImporto(stats.TOTALE_PAGAMENTI) }}€</span></div>
                                </div>
                            </div>

                            <!-- TOTALI GENERALI -->
                            <div class="mb-2 p-2 bg-light rounded" style="font-size: 0.8rem;">
                                <h6 class="mb-2" style="font-size: 0.85rem;"><i class="fas fa-calculator text-info"></i> <strong>TOTALI GENERALI</strong></h6>
                                <div class="row">
                                    <div class="col-4 mb-1">Contratti: <span class="badge badge-primary badge-pill">{{ stats.TOTALE_CONTRATTI }}</span></div>
                                    <div class="col-4 mb-1">Agenti: <span class="badge badge-info badge-pill">{{ stats.TOTALE_AGENTI }}</span></div>
                                    <div class="col-4 mb-1">Clienti: <span class="badge badge-info badge-pill">{{ stats.TOTALE_CLIENTI }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        <i class="fas fa-times"></i> Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

/* import Upload from '@/components/utils/germ/Upload.vue' */

export default {
    name: "Dashboard",
    components: {
/*         Upload */
    },
    data: function () {
        return {
            utente: {},
            tabella: "",
            dataUltimoOrdine: "",
            filters: global.filters,
            args: { modalita: "DCP_uploadFlusso"},
            elab: { modalita: "PROCESS_flussi" },
            scadenzeVicine: 0,
            stats: null
        }
    },
    methods: {
        openDettagliFatture() {
            utils.openModal('popUpDettagliFatture');
        },

        openDettagliContratti() {
            utils.openModal('popUpDettagliContratti');
        },

        moreInfo() {
            utils.openModal('popUpInfoStats');
        },

        esportaAgenti: function () {
            var url = utils.BASE_API + "dcp/report?ID_REPORT=3&SESSION_TOKEN=" + utils.SESSION_TOKEN + "&FORMATO=2&ORD=1";
            window.open(url);
        },

        loadStats: function() {
            utils.get('dcp/dashboard/stats', {}, (response) => {
                if (response.esito == 0) {
                    this.stats = response.data;
                }
            });
        },
        svuotaDb(){
            utils.ajax('dcp/svuota', {}, (response) => {
                if(response.esito == 0){
                    utils.alert.success('Db correttamente svuotato apparte agenti');
                }
            });
        },
        riassegnaAgente1917(){
            if (!confirm("Spostare i contratti dall'agente 19 all'agente 17 (esclusi i disattivi)?")) return;
            utils.ajax('dcp/agente/riassegna_19_17', {}, (response) => {
                if (response.esito == 0) {
                    var d = response.data;
                    utils.alert.success("Spostati " + d.spostati + " contratti su 17 (disattivi rimasti su 19: " + d.disattivi_rimasti + ")");
                    this.loadStats();
                } else {
                    utils.alert.error(response.messaggio || "Operazione fallita");
                }
            });
        },
        creaTabella: function () {
            utils.ajax('nic/generaclasse', { tabella: this.tabella }, (response) => {

            });
        },
        setFileType: function (fileType) {
            this.args.fileType = fileType;
        },
        successCaricamento: function () {
            utils.alert.success("Operazione correttamente eseguita");
            var modal = utils.closeModal('popUpUpload');
        },
        openUpload: function () {
            this.args.fileType = '';
            var modal = utils.openModal('popUpUpload');
        },
        elaboraDati: function () {
            global.utils.ajax('dcp/elabora_dati', { elab: this.elab }, (response) => {
                if (response.esito == 0) {
                    if (response.data && response.data.files && response.data.files.length > 0) {
                        utils.alert.warning(response.messaggio);
                    } else {
                        utils.alert.success("Elaborazione Eseguita Correttamente, le provviggioni sono state aggiornate");
                    }
                    this.loadStats();
                }
                else {
                    utils.alert.error(response.messaggio || "Elaborazione Fallita, controllare la correttezza di file caricati");
                }
            });
        },
        openInfoNomiFile: function () {
            utils.openModal('popUpInfoNomiFile');
        },
        openModulo: function (modulo) {
            global.router.push(modulo);
        },
        hasFunzionalita: function (id) {
            for (var i = 0; i < this.$root.utente.funzionalita.length; i++) {
                if (this.$root.utente.funzionalita[i].ID_FUNZIONALITA == id) {
                    return true;
                }
            }
            return false;
        },
    },
    computed: {
    },
    created: function () {

        this.hasFunzionalita();
        this.loadStats();

    },
}
</script>

<style scoped>
.zoom-wrapper {
    z-index: 1;
}

.zoom-wrapper:hover {
    z-index: 9999;
}

.zoom-panel {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.zoom-panel:hover {
    transform: scale(1.15);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.zoom-panel:active {
    transform: scale(1.05);
}
</style>